import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import {Add} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink} from "react-router-dom";
import currencies from "../../models/currencies";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';

export default function CurrencyIndex(props) {
    const [currenciesData, setCurrenciesData] = useState([])
    const {setShowLoader, showConfirm} = useRootHook();

    useEffect(() => {
        setShowLoader(true)
        currencies.index()
            .then((data) => {
                data && setCurrenciesData(data)
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }, [])

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Currencies"
                breadcrumbs={[['Dashboard', '/'], ['Currencies', '/currencies']]}
                actions={
                    <Button to="/currencies/add" component={RouterLink} variant="contained" startIcon={<Add />}>
                        Add currency
                    </Button>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
                <TableToolbar title="Currencies" />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Currency</TableCell>
                            <TableCell>Subunit</TableCell>
                            <TableCell>Available</TableCell>
                            <TableCell>Created</TableCell>
                            <TableCell>Modified</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {currenciesData.map((row) => (
                            <TableRow key={`customer-${row.id}`}>
                                <TableCell>
                                    <Link
                                        color="primary"
                                        to={`edit?id=${row.id}`}
                                        component={RouterLink}
                                        customer={row}
                                        onClick={async (ev) => {
                                            const confirmed = await showConfirm('Continue only if you know what you are doing!', 'Warning');
                                            if (!confirmed) ev.preventDefault();
                                        }}
                                    >
                                        {`${row.id}`}
                                    </Link>
                                </TableCell>
                                <TableCell>{row.currency}</TableCell>
                                <TableCell>{row.subunit}</TableCell>
                                <TableCell>{row.enabled !== false ? 'Yes' : 'No'}</TableCell>
                                <TableCell>{helpers.getDate(row.created)}</TableCell>
                                <TableCell>{helpers.getDate(row.modified)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </SectionCard>
        </Grid>
    </React.Fragment>
}
